import React from 'react';

const services = [
  {
    title: 'Custom Software Development',
    description: 'We build robust, scalable platforms tailored to your unique operational needs.',
    image: '/images/custom_software.png',
  },
  {
    title: 'Mobile App Development',
    description: 'Native and cross-platform mobile experiences designed for performance and usability.',
    image: '/images/mobile_app.png',
  },
  {
    title: 'AI & Data Solutions',
    description: 'Intelligent systems, data analytics, and workflow automation powered by modern AI.',
    image: '/images/ai_solutions.png',
  },
  {
    title: 'SaaS Platforms',
    description: 'End-to-end architecture and development for cloud-based software products.',
    image: '/images/saas_platform.png',
  },
];

const Services = () => {
  return (
    <section className="services" id="services">
      <div className="services__header reveal">
        <div className="services__label">{'// WHAT WE DO IN THE MEANTIME'}</div>
        <h2 className="services__heading">
          While we're building the future, we're still building for you.
        </h2>
        <p className="services__subheading">
          200 OK Studios continues to partner with ambitious teams to build custom 
          software, mobile applications, and AI integrations that solve hard problems.
        </p>
      </div>

      <div className="services__grid">
        {services.map((service, index) => (
          <div className={`service-card reveal reveal-delay-${index + 1}`} key={index}>
            <div className="service-card__image-wrap">
              <img src={service.image} alt={service.title} className="service-card__image" />
            </div>
            <div className="service-card__content">
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__description">{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
